import React from "react";
import { cn } from "@/lib/utils";

/**
 * MicroLabel — technical monospace label (SpaceX-like).
 * variant: "muted" | "blue"
 */
export const MicroLabel = ({ children, variant = "muted", className }) => {
  return (
    <span
      className={cn(
        "strato-micro inline-flex items-center",
        variant === "blue"
          ? "text-strato-blue"
          : "text-muted-foreground",
        className,
      )}
    >
      {children}
    </span>
  );
};
